export default __webpack_public_path__ + "static/media/QrCode.250df9b6.svg";